/* Andaluci: kortingscode in de winkelwagen.
   Koppelt de code via /cart/update.js aan de cart, zodat Shopify hem
   automatisch toepast in de checkout. Ongeldige codes worden direct
   weer verwijderd, zodat ze geen foutmelding geven in de checkout. */
if (!customElements.get('cart-discount')) {
  customElements.define(
    'cart-discount',
    class CartDiscount extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('.cart-discount__input');
        this.button = this.querySelector('.cart-discount__apply');
        this.error = this.querySelector('.cart-discount__error');

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.apply();
        });

        this.querySelectorAll('.cart-discount__remove').forEach((button) => {
          button.addEventListener('click', () => this.remove(button.dataset.code));
        });
      }

      currentCodes() {
        return [...this.querySelectorAll('.cart-discount__remove')].map((button) => button.dataset.code);
      }

      async update(codes) {
        const url = (window.routes && window.routes.cart_update_url) || '/cart/update';
        const response = await fetch(`${url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      }

      async apply() {
        const code = this.input.value.trim();
        this.showError('');

        if (!code) {
          this.showError('Vul een kortingscode in.');
          return;
        }

        const existing = this.currentCodes();
        if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) {
          this.showError('Deze code is al toegepast.');
          return;
        }

        this.setLoading(true);
        try {
          const cart = await this.update([...existing, code]);
          const match = (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());

          if (!match || !match.applicable) {
            await this.update(existing);
            this.showError('Deze code is niet geldig of geldt niet voor je winkelwagen.');
            return;
          }

          this.refresh();
        } catch (e) {
          this.showError('Er ging iets mis. Probeer het opnieuw.');
        } finally {
          this.setLoading(false);
        }
      }

      async remove(code) {
        this.showError('');
        try {
          await this.update(this.currentCodes().filter((c) => c !== code));
          this.refresh();
        } catch (e) {
          this.showError('Er ging iets mis. Probeer het opnieuw.');
        }
      }

      refresh() {
        const hasDrawer = document.querySelector('cart-drawer-items');
        if (hasDrawer && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount' });
        } else {
          window.location.reload();
        }
      }

      setLoading(isLoading) {
        this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.button.disabled = isLoading;
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }
    }
  );
}
